export const CHECKOUT3_ADDON_DATA=`CHECKOUT3_ADDON_DATA`;
export const CHECKOUT3_ADDON_FOR_ALL_PARTICIPANTS_DATA=`CHECKOUT3_ADDON_FOR_ALL_PARTICIPANTS_DATA`;
export const CHECKOUT3_ADDON_FOR_EACH_PARTICIPANTS_DATA=`CHECKOUT3_ADDON_FOR_EACH_PARTICIPANTS_DATA`;
export const CHECKOUT3_ADDON_DATA_CLEAR=`CHECKOUT3_ADDON_DATA_CLEAR`;